import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { translationKeys } from '../../../../sharedTranslationKeys';
import { Notification } from "../../+state/notifications/notifications.models";

@Component({
  selector: 'avano-notifications-item',
  templateUrl: './avano-notifications-item.component.html',
  styleUrls: ['./avano-notifications-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvanoNotificationsItemComponent {
  @Input() notification: Notification

  @Output() private readonly markAsRead: EventEmitter<number> = new EventEmitter<number>();

  @Output() private readonly deleteOne: EventEmitter<number> = new EventEmitter<number>();

  @Output() private readonly downloadReport: EventEmitter<{reportId, filename}> = new EventEmitter();

  translationKeys: typeof translationKeys = translationKeys;

  markedAsRead(id: number): void {
    this.markAsRead.emit(id);
  }

  delete(id: number): void {
    this.deleteOne.emit(id);
  }

  download(reportId: number, filename: string): void {
    this.downloadReport.emit({reportId, filename});
  }
}
